var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdviceCheck = function SvgAdviceCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12a7 7 0 1 0 14 0 7 7 0 0 0-14 0Zm7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.413 9.221a.56.56 0 0 1-.035.791L10.77 15.16 7.621 12.27a.56.56 0 0 1 .757-.825l2.391 2.194 4.852-4.453a.56.56 0 0 1 .792.034Z",
    fill: "currentColor"
  })));
};
export { SvgAdviceCheck as ReactComponent };
export default __webpack_public_path__ + "df6af2d346365bb749a4f74448f10e24.svg";